import styled from 'styled-components';
import { TypeSaleStatus, TypeSaleStatusColor, TypeSaleType, TypeSaleTypeColor } from '../../../components/enum/saleEnums';

export {
    ActionButton,
    Container,
    SearchCard as FilterCard,
    Table,
    TableContainer,
    Title,
} from '../../sharedTable.styled';

export const StatusCell = styled.td<{ status: TypeSaleStatus }>`
  font-weight: 700;
  color: ${({ status }) => TypeSaleStatusColor[status] || 'var(--text)'};
`;

export const TypeCell = styled.td<{ $saleType: TypeSaleType }>`
  font-weight: 700;
  color: ${({ $saleType }) => TypeSaleTypeColor[$saleType] || 'var(--text)'};
`;

export const PaymentStatusChip = styled.span<{ $overdue?: boolean }>`
  display: inline-block;
  margin-top: 2px;
  padding: 1px 7px;
  border-radius: 100px;
  font-size: 10.5px;
  font-weight: 800;
  color: ${({ $overdue }) => ($overdue ? '#fb7185' : '#f59e0b')};
  background: ${({ $overdue }) => ($overdue ? 'rgba(251,113,133,.12)' : 'rgba(245,158,11,.12)')};
`;
